import React, { useEffect, useState } from 'react'

import { MdLocalOffer, MdPlace, MdSend } from 'react-icons/md'
import { useHistory } from 'react-router-dom'

import { Grid } from '@material-ui/core'
import ILoteRequest from 'modules/lotes/domain/entities/LoteRequest'
import IVerificaCargaDisponivelImpl from 'modules/lotes/domain/usecases/VerificaCargaDisponivelImpl'
import { useDirecionaCarga } from 'modules/lotes/hooks/direcionaCarga'
import ILoteResponseData from 'modules/lotes/domain/entities/ILoteResponseData'
import { formatBreadCrumb } from 'shared/components/BasePage/formatBreadCrumb'
import Button from 'shared/components/Button'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import SnackBar from 'shared/components/SnackBar'
import { ContainerLoading } from 'shared/pages/Dashboard/styles'
import { registerEvent } from 'shared/services/TrackingGAService'
import { colors } from 'shared/styles/colors'
import Formatter, { numberToCurrency } from 'shared/utils/formatters'
import iconEspecie from 'shared/assets/icons/drive/icon-especie.svg'
import iconFilial from 'shared/assets/icons/drive/icon-filial.svg'
import iconPedagio from 'shared/assets/icons/drive/icon-pedagio.svg'
import iconSoja from 'shared/assets/icons/drive/icon-soja.svg'
import Loading from 'shared/components/Loading'

import { IFindById } from '../../domain/usecases/FindByIdImpl'
import { ILoteCardProps } from '../components/LoteCard/CardComponent.types'
import LabelValue from './components/LabelValue'
import LabelValueLocal from './components/LabelValueLocal'
import MapaLote from './components/Mapa'
import OutrasOfertas from './components/OutrasOfertas'
import {
  BreadCrumb,
  ContainerCards,
  Content,
  Detalhes,
  Title,
  TitleArea,
} from './styles'
import ValidateRequisitosViagemImpl from 'modules/user/domain/usecases/ValidateRequisitosViagemImpl'
import { ListFrotista } from 'modules/user/domain/usecases/ListFrotista'
import EStatusConta from 'modules/lotes/domain/entities/EStatusConta'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import ModalRequisitosViagem from '../ListLotes/ModalRequisitosViagem'
import ModalMultiplosCnpjsRequisitosViagem from '../ListLotes/ModalMultiplosCnpjsRequisitosViagem'
import ValidateLoteQuarteirizadoImpl from 'modules/lotes/domain/usecases/ValidateLoteQuarteirizado'

type TProps = {
  findById: IFindById
  verificaCargaDisponivel: IVerificaCargaDisponivelImpl
  validateRequisitosViagem: ValidateRequisitosViagemImpl
  listFrotistas: ListFrotista
  validateLoteQuarteirizado: ValidateLoteQuarteirizadoImpl
}

const DetalhesCargaScreen: React.FC<TProps> = ({
  findById,
  verificaCargaDisponivel,
  validateRequisitosViagem,
  listFrotistas,
  validateLoteQuarteirizado,
}) => {
  const history = useHistory()
  const data = history.location.state
  const {
    lote,
    setLote,
    cidadeDestino,
    setCidadeDestino,
    cidadeOrigem,
    setCidadeOrigem,
  } = useDirecionaCarga()
  const [loading, setLoading] = useState(true)
  const [lotes, setLotes] = useState<ILoteResponseData[]>()
  const [indexLote, setIndexLote] = useState(-1)
  const [loadingBackdrop, setLoadingBackdrop] = useState(false)
  const [messages, setMessages] = useState('')
  const [open, setOpen] = useState(false)
  const { frotistas, setFrotistas } = useFrotista()
  const [openModalRequisitos, setOpenModalRequisitos] = useState(false)
  const [
    openModalRequisitosMultiplosCnpjs,
    setOpenModalRequisitosMultiplosCnpjs,
  ] = useState(false)
  const [requisitosViagem, setRequisitosViagem] = useState({})

  useEffect(() => {
    const loteParam = (data as ILoteCardProps)?.lote

    if (loteParam) {
      const loadLotes = () => {
        const lotesParam = (data as ILoteCardProps)?.lotes
        const indexLoteAtual = (data as ILoteCardProps)?.index
        setIndexLote(indexLoteAtual)
        setLotes(lotesParam)
        setCidadeOrigem(loteParam.origem)
        setCidadeDestino(loteParam.destino)
      }
      loadLotes()
    }
  }, [data, lotes])

  useEffect(() => {
    const loteParam = (data as ILoteCardProps)?.lote

    if (loteParam) {
      const fetchData = async (values: any) => {
        try {
          const response = await findById.execute({ id: values })
          setLote(response)
          setLoading(false)
        } catch (error) {
          setLoading(false)
        }
      }
      fetchData(loteParam.id)
    }
  }, [data, findById])

  const isLoteQuarteirizado = async (idLote: number) => {
    const loteQuarteirizado = await validateLoteQuarteirizado.execute(idLote)
    return loteQuarteirizado
  }

  const temCnpjsSemContaPay = async (): Promise<boolean> => {
    if (frotistas.length === 1) {
      return false
    }

    const result = await listFrotistas.execute({
      nome: '',
      page: 1,
      per_page: 999,
      active: true,
    })
    let frotistaSemContaPay = false
    result.data.forEach(frotista => {
      if (
        frotista.status_conta !== EStatusConta.ATIVA &&
        frotista.status_conta !== EStatusConta.CONTA_NAO_NECESSARIA
      ) {
        frotistaSemContaPay = true
      }
    })
    setFrotistas(result.data)
    setLoading(false)
    return frotistaSemContaPay
  }

  const frotistaUnicoSemContaPay = async (): Promise<boolean> => {
    if (frotistas.length > 1) {
      return false
    }

    const result = await validateRequisitosViagem.execute(frotistas[0].id)

    if (
      result.data.caminhao.value !== 'OK' ||
      result.data.tmovPay.value !== 'OK' ||
      result.data.motorista.value !== 'OK' ||
      result.data.veiculo.value !== 'OK'
    ) {
      setLoading(false)
      setRequisitosViagem(result.data)
      return true
    }
  }

  const validaLote = async (loteId: number) => {
    setLoadingBackdrop(true)
    const response = await verificaCargaDisponivel.execute(loteId)
    setLoadingBackdrop(false)

    const isFrotistaUnicoSemContaPay = await frotistaUnicoSemContaPay()
    const isLoteQuarteirizacao = await isLoteQuarteirizado(loteId)
    const temCnpjsSemConta = await temCnpjsSemContaPay()

    if (response.isValid) {
      if (isLoteQuarteirizacao && isFrotistaUnicoSemContaPay) {
        history.push({
          pathname: '/tmov-pay-instructions',
          state: { quarteirizacao: true },
        })
        return
      }
      if (temCnpjsSemConta) {
        setOpenModalRequisitosMultiplosCnpjs(true)
        return 'sem_conta'
      }

      if (isFrotistaUnicoSemContaPay) {
        setOpenModalRequisitos(true)
        return 'sem_conta'
      }

      history.push('/direciona-carga')
    } else {
      setOpen(true)
      setMessages('Ops, esta carga está indisponível')
    }
  }

  const iniciarDirecionamentoCarga = async (
    loteId: number,
    origem: string,
    destino: string,
  ) => {
    registerEvent({
      categoria: 'Direcionamento de Carga',
      acao: 'Click Enviar Carga',
      local: 'Botao na tela de Detalhes da Carga',
    })

    try {
      const responseFindById = await findById.execute({ id: loteId })

      setCidadeOrigem(origem)
      setCidadeDestino(destino)
      setLote(responseFindById)

      await validaLote(loteId)
    } catch (error: unknown) {
      if (error instanceof Error) {
        setMessages(error.message)
      } else {
        setMessages('Erro ao tentar buscar o lote pelo id')
      }
    }
  }
  const enviarCarga = async (loteId: number) => {
    setLoadingBackdrop(true)
    const response = await verificaCargaDisponivel.execute(loteId)
    setLoadingBackdrop(false)

    if (response.isValid) {
      try {
        const responseFindById = await findById.execute({ id: loteId })

        setLote(responseFindById)
        history.push('/direciona-carga')
      } catch (error: unknown) {
        if (error instanceof Error) {
          setMessages(error.message)
        } else {
          setMessages('Erro ao tentar buscar o lote pelo id')
        }
      }
    } else {
      setOpen(true)
      setMessages('Ops, esta carga está indisponível')
    }
  }

  const handleDetalhes = async (
    lote: ILoteRequest,
    origem: string,
    destino: string,
  ) => {
    setLoadingBackdrop(true)
    try {
      const response = await verificaCargaDisponivel.execute(lote.id)

      if (response.isValid) {
        const responseFindById = await findById.execute({ id: lote.id })
        setCidadeOrigem(origem)
        setCidadeDestino(destino)
        setLote(responseFindById)
      } else {
        setMessages(response.messages?.join(' '))
        setOpen(true)
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        setMessages(error.message)
      } else {
        setMessages('Erro ao lidar com detalhes do lote')
      }
    } finally {
      setLoadingBackdrop(false)
    }
  }

  const getDetalhes = () => {
    if (loading) {
      return (
        <ContainerLoading>
          <Loading color={colors.green} />
        </ContainerLoading>
      )
    }

    return (
      <Grid item xs={12} md={6}>
        <Detalhes>
          <TitleArea>Detalhe da carga</TitleArea>

          <Grid item xs={12}>
            <LabelValue title="Frete" value={'#' + lote?.id.toString()} />
          </Grid>

          <Grid item xs={12}>
            <LabelValueLocal
              icon={MdPlace}
              title="Origem"
              subtitle={cidadeOrigem?.toUpperCase()}
              value={lote?.origem}
            />
          </Grid>

          <Grid item xs={12}>
            <LabelValueLocal
              icon={MdPlace}
              title="Destino"
              subtitle={cidadeDestino?.toUpperCase()}
              value={lote?.destino}
            />
          </Grid>

          <Grid container>
            <Grid item xs={6}>
              <LabelValue
                icon={MdLocalOffer}
                title="Valor"
                value={numberToCurrency(lote?.valor)}
              />
            </Grid>
            <Grid item xs={6}>
              <LabelValue
                title="Espécie"
                value={lote?.especie}
                iconFile={iconEspecie}
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={6}>
              <LabelValue
                title="Produto"
                value={lote?.produto}
                iconFile={iconSoja}
              />
            </Grid>
            <Grid item xs={6}>
              <LabelValue
                title="Pedágio"
                value={lote?.pedagio}
                iconFile={iconPedagio}
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={6}>
              <LabelValue
                title="Total do pedágio na rota"
                value={lote?.total_pedagio?.toString()}
                iconFile={iconPedagio}
              />
            </Grid>
            <Grid item xs={6}>
              <LabelValue
                title="Filial"
                value={lote?.filial}
                iconFile={iconFilial}
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <LabelValue
              title="Observações"
              value={lote?.observacoes}
              icon={MdLocalOffer}
            />
          </Grid>

          <Grid container justifyContent={'flex-end'}>
            <Button
              onClick={() => validaLote(lote.id)}
              color={colors.green}
              style={{ margin: '20px 20px 20px 0px' }}
            >
              <MdSend />
              Enviar carga
            </Button>
          </Grid>
        </Detalhes>
      </Grid>
    )
  }

  const getOutrasOfertas = () => {
    if (!lotes) {
      return (
        <ContainerLoading>
          <Loading color={colors.green} />
        </ContainerLoading>
      )
    }
    return (
      <Grid item xs={4} md={12}>
        <OutrasOfertas
          lotes={lotes}
          index={indexLote}
          verificaCargaDisponivel={verificaCargaDisponivel}
          enviaCarga={iniciarDirecionamentoCarga}
          visualizaCarga={handleDetalhes}
        />
      </Grid>
    )
  }

  const posicaoOrigem = {
    uid: 1,
    nome: `Origem - ${Formatter.textoCapitular(lote?.origem)}`,
    coordenadas: {
      latitude: lote?.latitudeOrigem,
      longitude: lote?.longitudeOrigem,
    },
  }

  const posicaoDestino = {
    uid: 2,
    nome: `Destino - ${Formatter.textoCapitular(lote?.destino)}`,
    coordenadas: {
      latitude: lote?.latitudeDestino,
      longitude: lote?.longitudeDestino,
    },
  }

  const getMapa = () => {
    return (
      <Grid item xs={12} md={6}>
        <div
          style={{ backgroundColor: '#CCC', height: '100vh', maxHeight: 600 }}
        >
          <MapaLote origem={posicaoOrigem} destino={posicaoDestino} />
        </div>
      </Grid>
    )
  }

  return (
    <Content>
      <BreadCrumb>
        <Title>
          {formatBreadCrumb('Ofertas de cargas / Detalhe da carga')}
        </Title>
      </BreadCrumb>
      <ContainerCards>
        <Grid container spacing={3}>
          {getDetalhes()}
          {getMapa()}
          {getOutrasOfertas()}
        </Grid>

        {loadingBackdrop ? (
          <LoadingBackdrop open={loadingBackdrop} color={colors.green} />
        ) : (
          <SnackBar
            open={open}
            message={messages}
            setOpen={setOpen}
            severity={'error'}
          />
        )}
      </ContainerCards>

      <ModalRequisitosViagem
        openModalRequisitos={openModalRequisitos}
        setOpenModalRequisitos={setOpenModalRequisitos}
        requisitosViagem={requisitosViagem}
      />
      <ModalMultiplosCnpjsRequisitosViagem
        openModalRequisitos={openModalRequisitosMultiplosCnpjs}
        setOpenModalRequisitos={setOpenModalRequisitosMultiplosCnpjs}
        frotistas={frotistas}
        direcionamentoCarga={enviarCarga}
      />
    </Content>
  )
}

export default DetalhesCargaScreen
